import { getAuthToken, isAuthTokenExpired } from '@cash-rewards/reactjs';
import { useEffect, useState } from 'react';

const useAuthStatus = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  useEffect(() => {
    const checkAuthStatus = async () => {
      const token = await getAuthToken();
      if (token && !isAuthTokenExpired()) {
        setIsAuthenticated(true);
      } else {
        setIsAuthenticated(false);
      }
    };

    checkAuthStatus();
  }, []);

  return isAuthenticated;
};

export default useAuthStatus;
